"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M514.86 295.23H28.44a28.45 28.45 0 010-56.89h486.42c13.22-64.82 70.71-113.78 139.36-113.78s126.14 49 139.36 113.78h202a28.45 28.45 0 010 56.89h-202C780.36 360.05 722.88 409 654.22 409s-126.14-48.95-139.36-113.77zm139.36-113.78a85.34 85.34 0 1085.34 85.34 85.44 85.44 0 00-85.34-85.34zm-423.8 625.78h-202a28.45 28.45 0 010-56.89h202c13.22-64.82 70.7-113.78 139.36-113.78s126.14 49 139.36 113.78h486.42a28.45 28.45 0 010 56.89H509.14C495.92 872.05 438.43 921 369.78 921s-126.14-48.95-139.36-113.77zm139.36-113.78a85.34 85.34 0 1085.33 85.34 85.45 85.45 0 00-85.33-85.34z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgFilter, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;